export function validateRequiredFields<T>(
  obj: T,
  requiredFields: Array<keyof T>,
): (keyof T)[] {
  return requiredFields.filter((field) => {
    const value = obj[field];
    return (
      value === undefined ||
      value === null ||
      (typeof value === 'string' && value === '')
    );
  });
}
